import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Expander from 'components/common/Expander'
import { TireSizeSelector } from 'components/VehicleConfigurator'

const CustomTireSize = ({
  handlers,
  model,
  tireSize: { front, rear } = {},
  handleRearTireSizeToggle
}) =>
  <Fragment>
    <div data-at-custom-tire-size="front">
      <Col data-at-text>Front</Col>
      <Selector>
        <TireSizeSelector
          noSpace
          data={ front }
          model={ model.front }
          handlers={ handlers.front } />
      </Selector>
    </div>
    <CustomExpander title="Add a Different Rear Tire Size" onClick={ handleRearTireSizeToggle }>
      <Col data-at-text>Rear</Col>
      <Selector>
        <TireSizeSelector
          noSpace
          data={ rear }
          model={ model.rear }
          handlers={ handlers.rear } />
      </Selector>
    </CustomExpander>
  </Fragment>

export default CustomTireSize

CustomTireSize.propTypes = {
  handleRearTireSizeToggle: PropTypes.func,
  handlers: PropTypes.shape({
    rear: PropTypes.object,
    front: PropTypes.object
  }),
  model: PropTypes.shape({
    rear: PropTypes.object,
    front: PropTypes.object
  }),
  tireSize: PropTypes.shape({
    front: PropTypes.object,
    rear: PropTypes.object
  })
}

const CustomExpander = styled(Expander)`
  margin-top: 15px;
`

const Col = styled.div`
  display: table-cell;
  min-width: 50px;
  font-weight: 600;
  vertical-align: middle;
`

const Selector = styled.div`
  display: table-cell;
  width: 100%;
  vertical-align: middle;
`
